module.exports = __webpack_public_path__ + "img/import.8bf96a77.svg";